module.exports = __webpack_public_path__ + "img/hama.c100cc2d.png";